import gql from 'graphql-tag';

export const GET_INTEGRATION_SETTINGS_VALUES_BY_NAME = gql`
  query GetIntegrationSettingsValuesByName($input: IntegrationSettingsValuesInput) {
    integrationSettingsValues(input: $input) {
      integrationName
      accountId
      userProfileId
      locationId
    }
  }
`;
